module.exports = "/_next/static/resources/photo-3-d8ba940b3a6bf7a647f7e85b659592ce.webp";